// extracted by mini-css-extract-plugin
export default {"btn_to_basket":"style_btn_to_basket__cCl-X"};